<template>
  <section>
    <h1 class="text-h3 mb-8">
      Buttons
    </h1>
    <v-sheet
      class="mb-4 px-6 pt-4"
      outlined
      rounded
    >
      <div class="d-flex">
        <v-checkbox
          v-model="loading"
          label="Loading"
        />
        <v-checkbox
          v-model="disabled"
          class="ml-8"
          label="Disabled"
        />
      </div>
      <v-container>
        <div
          v-for="color in colors"
          :key="color"
          class="mb-4"
        >
          <div
            v-if="color"
            class="text-body-1 grey--text text--darken-1"
          >
            <strong>{{ color }}</strong>
          </div>
          <v-row no-gutters>
            <v-col
              v-for="type in types"
              :key="type"
              class="py-0"
            >
              <div
                v-for="size in sizes"
                :key="size"
                class="my-3"
              >
                <v-btn
                  :color="color"
                  :loading="loading"
                  :disabled="disabled"
                  v-bind="getBinding(type, size)"
                >
                  <v-icon
                    :left="type !== 'fab'"
                  >
                    fa-solid fa-trash
                  </v-icon>
                  <template v-if="type !== 'fab'">
                    {{ size || 'Normal' }}
                  </template>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/buttons/">
      <strong>Buttons</strong>
    </external-link>
    <external-link href="https://vuetifyjs.com/en/components/floating-action-buttons/">
      <strong>Buttons: Floating Action Button</strong>
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'FormButtons',
  data: () => ({
    colors: [
      '',
      'primary',
      'primary gradient',
      'secondary',
      'secondary gradient'
    ],
    types: [
      '',
      'text',
      'outlined',
      'fab'
    ],
    sizes: [
      'x-small',
      'small',
      '',
      'large',
      'x-large'
    ],
    disabled: false,
    loading: false
  }),
  methods: {
    getBinding (type, size) {
      const result = {}
      if (type) {
        result[type] = true
      }
      if (size) {
        result[size] = true
      }
      return result
    }
  }
}
</script>
